import { Text } from '../../atoms/Text';
import { Stack } from '../../atoms/Stack';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface FormFieldProps extends CoreProps {
  label?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FormField({
  label,
  error,
  required,
  children,
  testId,
  view = 'all',
}: FormFieldProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;

  return (
    <Stack gap={4} data-testid={testId}>
      {label ? (
        <Text size="sm" fw={500}>
          {label}
          {required ? ' *' : ''}
        </Text>
      ) : null}
      {children}
      {error ? (
        <Text size="xs" c="red">
          {error}
        </Text>
      ) : null}
    </Stack>
  );
}
